// extracted by mini-css-extract-plugin
module.exports = {"mostUsedQueriesWrapper":"_1-I06WQW_CjNwuT59CFnfK","mostUsedQueriesTitle":"WA-krbZ6zo8wLMFL5AbLf"};